<template>

    <v-form ref="formRef" v-model="formValid">
        <v-row dense>
            <!-- <v-col cols="12" md="6">
                <v-select v-model="form.id_keuangan_kategori" :items="categories" label="Cabang" item-text="value"
                    item-value="id" :rules="[rules.required]" outlined danse />
            </v-col>
            <v-col cols="12" md="6">
                <template>
                    <v-menu v-model="menu" :close-on-content-click="false" transition="scale-transition" offset-y
                        min-width="290px" style="margin-top: 1px;">
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field v-model="yearMonth" label="Periode" prepend-inner-icon="mdi-calendar" readonly
                                outlined  v-bind="attrs" v-on="on"></v-text-field>
                        </template>

                        <v-date-picker v-model="picker" type="month" @input="setYearMonth" scrollable
                            color="primary"></v-date-picker>
                    </v-menu>
                </template>
            </v-col> -->

            <v-col cols="12" md="6">
                <v-select v-model="form.id_keuangan_kategori" :items="categories" label="Category" item-text="value"
                    item-value="id" :rules="[rules.required]" outlined danse />
            </v-col>
            <v-col cols="12" md="6">
                <v-text-field v-model="form.amount" label="Amount" :rules="[rules.required]" outlined danse />
            </v-col>
            <!-- Nama -->
            <v-col cols="12" md="12">
                <v-textarea v-model="form.description" label="Description" :rules="[rules.required]" outlined danse />
            </v-col>

            <v-col cols="12" md="6">
                <v-text-field v-model="form.due_date" type="date" label="Due Date" :rules="[rules.required]" outlined
                    danse />

            </v-col>
            <v-col cols="12" md="6">

                <v-select v-model="form.status" :items="[
                    // { text: 'Lunas', value: 'lunas' },
                    { text: 'Belum Lunas', value: 'belum lunas' }
                ]" label="Status" item-text="text" item-value="value" :rules="[rules.required]" outlined danse />
            </v-col>
            <!-- Tombol Simpan -->
            <v-col cols="12" md="12" class="text-right">
                <v-btn color="primary" @click="submitForm">Simpan</v-btn>
            </v-col>
        </v-row>
    </v-form>

</template>


<script>
import { EventBus } from './../../../event-bus'
import KantorCabang from '../../../base-components/KantorCabang.vue';
export default {
    components: {
        KantorCabang
    },
    props: {
        editData: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            form: {
                id_keuangan_kategori: '',
                amount: '',
                description: '',
                due_date: '',
                status: '',
                type: 'utang'
            },
            formValid: false,
            categories: [],
            rules: {
                required: v => !!v || 'Harus diisi',
            },
            menu: false,
            yearMonth: '',
            picker: null,
        };
    },
    methods: {
        setYearMonth(date) {
            this.yearMonth = date.substr(0, 7); // Ambil hanya tahun dan bulan
            this.menu = false;
        },
        async fetchCategory() {
            const kategori = await axios.get(`api/keuangan/kategori_list?q=3`);
            this.categories = kategori.data.data;
            console.log(kategori.data.data)

        },

        async submitForm() {
            const valid = await this.$refs.formRef.validate();
            if (!valid) return;

            try {
                if (this.form.id_debts) {
                    // update
                    const data = await axios.put(`/api/utang/${this.form.id_debts}`, this.form);
                    Toast.fire({
                        icon: 'success',
                        title: data.data.message
                    });
                } else {
                    // create
                    const data = await axios.post(`/api/utang/store`, this.form);
                    Toast.fire({
                        icon: 'success',
                        title: data.data.message
                    });

                }
                EventBus.$emit('utang:updated');
                EventBus.$emit('modal:close');
            } catch (err) {
                console.error(err);
                alert('Gagal menyimpan data');
            }
        },

    },
    mounted() {
        this.fetchCategory();
        if (this.editData && this.editData.id_debts) {
            this.form = { ...this.form, ...this.editData };
        }
    }

};
</script>